import { i18n } from '@/i18n';
import { ExecActState, ExecChainActState } from '@tencent/wphk-act-base-cgi';
import { showBusinessError } from '@tencent/wphk-components-dialog';

export function showActExecDialog(execState: ExecActState|ExecChainActState|undefined) {
  switch (execState) {
    case ExecActState.fail:
    case ExecActState.innerFail:
      showBusinessError({ retmsg: i18n('領取失敗，請稍後重試') });
      break;
    case ExecActState.stockNotEnough:
      showBusinessError({ retmsg: i18n('券已兌罄') });
      break;
    default:
      showBusinessError({ retmsg: i18n('領取失敗，請稍後重試') });
      break;
  }
}
